import { render, staticRenderFns } from "./scroll-view-dropdown.vue?vue&type=template&id=6874ff1f&"
import script from "./scroll-view-dropdown.vue?vue&type=script&lang=ts&"
export * from "./scroll-view-dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./scroll-view-dropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports